"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.SavedClusterList = exports.SavedCluster = void 0;
const ClusterList_1 = __importDefault(require("./ClusterList"));
const axios_1 = __importDefault(require("axios"));
const exception2alert_1 = __importDefault(require("@common/tsutils/exception2alert"));
const lodash_1 = __importDefault(require("lodash"));
class User {
    constructor(raw) {
        this.id = +raw.id;
        this.name = raw.name;
        this.lastname = raw.lastname;
        this.email = raw.email;
    }
    get fullname() {
        return `${this.name} ${this.lastname}`.trim();
    }
}
class SavedCluster {
    constructor(raw, parcels, num_clusters, sampleDisableFn) {
        this.id = raw.id;
        this.name = raw.name;
        this.shared = raw.shared;
        this.mine = raw.mine;
        this.data = raw.data;
        this.creator = new User(raw.creator);
        this.num_clusters = raw.num_clusters;
        this.parcels = parcels;
        this.editor_num_clusters = num_clusters;
        this.sampleDisableFn = sampleDisableFn;
        this.valid = this.validate();
    }
    validate() {
        const clusters = lodash_1.default.take(this.data, this.editor_num_clusters);
        for (const c of clusters) {
            for (const s of c.samples) {
                if (!this.findSample(s)) {
                    console.warn("Missing sample", s);
                    return false;
                }
            }
        }
        return true;
    }
    findSample(code) {
        for (const p of this.parcels) {
            for (const s of p.samples) {
                if (s.code === code)
                    return s;
            }
        }
        return null;
    }
    build() {
        if (!this.valid) {
            throw new Error('This is a invalid saved cluster');
        }
        const clist = new ClusterList_1.default(this.editor_num_clusters, this.name);
        const savedClusters = lodash_1.default.take(this.data, this.editor_num_clusters);
        savedClusters.map((data, i) => {
            clist.clusters[i].name = data.name;
            for (const s of data.samples) {
                const sample = this.findSample(s);
                if (!this.sampleDisableFn(sample)) {
                    clist.clusters[i].add(sample);
                }
            }
        });
        return clist;
    }
    async delete() {
        try {
            await axios_1.default.delete(`/toolkit/common/api/saved_clusters/${this.id}`);
        }
        catch (e) {
            (0, exception2alert_1.default)(e);
            throw new Error('Error deleting cluster');
        }
    }
}
exports.SavedCluster = SavedCluster;
class SavedClusterList {
    constructor() {
        this.loaded = false;
        this.clusters = [];
    }
    async save(clusters, name, shared) {
        const data = {
            name,
            shared,
            data: clusters.toSavePayload(),
        };
        await axios_1.default.post('/toolkit/common/api/saved_clusters', data);
    }
    async load(parcels, num_clusters, sampleDisableFn) {
        try {
            this.loaded = false;
            const data = (await axios_1.default.get('/toolkit/common/api/saved_clusters')).data;
            this.clusters = data.map((raw) => new SavedCluster(raw, parcels, num_clusters, sampleDisableFn));
            this.loaded = true;
        }
        catch (e) {
            (0, exception2alert_1.default)(e);
            throw new Error('Error receiving cluster list');
        }
    }
}
exports.SavedClusterList = SavedClusterList;
